import { isEmpty } from 'lodash'

export const getMultilineValue = (formItems: Array<any> | undefined) =>
  formItems
    ?.filter((item) => !isEmpty(item?.value) || !isEmpty(item?.['@id']))
    ?.map((item) => item?.value || item?.['@id']) || []
